import { Point } from "pixi.js";

export class BasicSymbolType {
    public static readonly WILD: string = "W";
    public static readonly SCATTER: string = "S1";
    public static readonly BONUS: string = "B";
    public static readonly MYSTERY: string = "M";
    public static readonly XWILD: string = "XWILD";
    public static readonly EMPTY: string = "X";
}

export interface SymValue {
    [name: string]: SymValueData;
}
export interface SymValueData {
    [name: string]: SymValueDataData;
}
export interface SymValueDataData {
    [name: string]: number;
}

export interface ISymbolConfig {
    NAME: string;
    MULTI_STATES?: { [NAME: string]: ISymbolMultiState[] } | ISymbolMultiState | undefined;
    NORMAL_STATES?: { [NAME: string]: ISymbolNormalState[] } | ISymbolNormalState | undefined;
}

export interface ISymbolDim {
    WIDTH: number;
    HEIGHT: number;
    PADDING_X: number;
    PADDING_Y: number;
    SCALE: Point;
}

export interface ISymbolMultiState {
    [STATE: string]: { [TYPE: string]: ISymbolStateData };
}

export interface ISymbolNormalState {
    [STATE: string]: ISymbolStateData;
}

export interface ISymbolStateData {
    DIM?:ISymbolDim;
    TEXTURE_PATH?:string;
    STACKED_SIZE?:number;
}